__turbopack_context__.v({
  "centered": "LegalIntro-module__crfaHa__centered",
  "date": "LegalIntro-module__crfaHa__date",
  "description": "LegalIntro-module__crfaHa__description",
  "eyebrow": "LegalIntro-module__crfaHa__eyebrow",
  "intro": "LegalIntro-module__crfaHa__intro",
  "ornament": "LegalIntro-module__crfaHa__ornament",
  "ornamentDiamond": "LegalIntro-module__crfaHa__ornamentDiamond",
  "ornamentLine": "LegalIntro-module__crfaHa__ornamentLine",
  "title": "LegalIntro-module__crfaHa__title",
});
